import React, { useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import pageBanner from '../images/blank/service-banner.jpg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import pointDifImg1 from '../images/blank/point-dif-img.avif';
import pointDifImg2 from '../images/blank/point-dif-img-2.jpg';
import pointDifImg3 from '../images/blank/point-dif-img-3.jpg';
import pointDifImg4 from '../images/blank/point-dif-img-4.jpg';
import solutionPartnerImg1 from '../images/dt-solution-partner1.svg';
import solutionPartnerImg2 from '../images/dt-solution-partner2.svg';

const Services = () => {
  const swiperRef = useRef(null);

  const handlePrev = () => {
    swiperRef.current?.swiper.slidePrev();
  };

  const handleNext = () => {
    swiperRef.current?.swiper.slideNext();
  };

  return (
    <div>
      <div className="page-detail-top-header bg-black">
        <div className="page-breadcrumb o-container wd-container">
          <div className="breadcumb-content flex justify-between py-8">
            <div className="prev-page">
              <Link to="#" className='flex items-center gap-4'>
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="14" cy="14" r="13.5" fill="#E2E2E2" stroke="black"/>
                  <path d="M13.7405 9.05324L9.66113 12.7768C9.2434 13.1581 9.22476 13.8097 9.62001 14.2143L13.7405 18.4317" stroke="black" strokeWidth="1.6"/>
                  <path d="M9.63428 13.4744H18.8448" stroke="black" strokeWidth="1.6"/>
                </svg>
                <span>Cloud</span>
              </Link>
            </div>
            <div className="other-link">
              <Link to="#" className='active'>Services</Link>
              <Link to="#">Case Study</Link>
              <Link to="#">Report</Link>
              <Link to="#">Partners</Link>
            </div>
          </div>
        </div>
        <div className="detail-page-top-title o-container wd-container bg-black">
          <h1 className='text-white square-text-icon'>Services</h1>
          <div className="desc text-white">We don't just build apps, we build global brands. Let's grow together.</div>
        </div>
      </div>
      <div className="page-banner">
        <div className='o-container wd-container small'>
          <div className="banner-content">
            <div className="banner-img">
              <img src={pageBanner} alt="" />
            </div>
            <div className="banner-title">
              <h2>Discover the Power of Cloud in <br/>Digital Transformation!</h2>
              <div className="bt">
                <span>Cloud</span>
                <span>Transformaiton</span>
                <span>Digital</span>
                <span>Discover</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='services-content'>
        <div className='o-container wd-container'>
          <div className='services-content-inner'>
            <div className="sub-title">Global Transformation</div>
            <h2>Discover the Power of Cloud in Digital Transformation!</h2>
            <div className="two-desc">
              <div className="desc">As Blueprint, with over ten years of experience in data and cloud technologies, we see that every corporate structure needs its own unique technological transformation map. In this direction, we create the most accurate strategic foundations for the digital structures of businesses, </div>
              <div className="desc">select and customize the most appropriate cloud service, and build the entire transformation process on this foundation. By moving the infrastructures of institutions to cloud systems, we increase their compatibility and flexibility and reduce their costs.</div>
            </div>
            <div className='services-content-value'>
              <div className="value-item">
                <div className="value-title">
                  <h3>Cost <br/>Savings</h3>
                  <div className="value">35<sup>%</sup></div>
                </div>
                <div className="value-desc">Cloud services can significantly reduce traditional infrastructure costs.</div>
              </div>
              <div className="value-item">
                <div className="value-title">
                  <h3>Accessibility <br/>and Mobility</h3>
                  <div className="value">25<sup>%</sup></div>
                </div>
                <div className="value-desc">Cloud computing provides access to your data and applications from anywhere with an internet connection.</div>
              </div>
              <div className="value-item">
                <div className="value-title">
                  <h3>Scalability <br/>and Flexibility</h3>
                  <div className="value">25<sup>%</sup></div>
                </div>
                <div className="value-desc">Cloud computing allows you to allocate more resources when your workload increases or release unnecessary resources when it decreases. This dynamic scalability increases business continuity and performance. </div>
              </div>
              <div className="value-item">
                <div className="value-title">
                  <h3>Security and <br/>Data Protection</h3>
                  <div className="value">15<sup>%</sup></div>
                </div>
                <div className="value-desc">Cloud computing maximizes your security thanks to thedepth and breadth of security features it offers, automated maintenance and centralized management</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="dt-our-services">
        <div className='o-container wd-container'>
          <div className="p-top text-white mb-11 max-w-[1100px] mx-auto">
            <h2 className="text-white square-text-icon color-light-green mb-2">Our points of difference</h2>
            <p className="text-lg">We don't just build apps, we build global brands. Let's grow together.</p>
          </div>
          <div className="our-services-slider-container relative">
            <Swiper
              ref={swiperRef}
              modules={[Autoplay, Pagination, Navigation]}
              spaceBetween={0}
              slidesPerView={1}
              navigation={false}
              pagination={false}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              loop={true}
            >
              <SwiperSlide>
                <div className="banner-content">
                  <div className="banner-img">
                    <img src={pageBanner} alt="" />
                  </div>
                  <div className="banner-title">
                    <h2>Cloud Migration and Transformation <br/>Strategies</h2>
                  </div>
                </div>
                <div className="sub-desc">
                  <div className="bl-title">Next service</div>
                  <h3 className="title">Security and Data Protection Strategies</h3>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="banner-content">
                  <div className="banner-img">
                    <img src={pageBanner} alt="" />
                  </div>
                  <div className="banner-title">
                    <h2>Cloud Migration and Transformation <br/>Strategies</h2>
                  </div>
                </div>
                <div className="sub-desc">
                  <div className="bl-title">Next service</div>
                  <h3 className="title">Security and Data Protection Strategies</h3>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="banner-content">
                  <div className="banner-img">
                    <img src={pageBanner} alt="" />
                  </div>
                  <div className="banner-title">
                    <h2>Cloud Migration and Transformation <br/>Strategies</h2>
                  </div>
                </div>
                <div className="sub-desc">
                  <div className="bl-title">Next service</div>
                  <h3 className="title">Security and Data Protection Strategies</h3>
                </div>
              </SwiperSlide>
            </Swiper>
            <div className="our-services-arrow">
              <div className="prev-arrow" onClick={handlePrev}>
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="15" cy="15" r="15" fill="#E2E2E2"/>
                  <path d="M10.2002 15H19.8002" stroke="black" strokeWidth="1.4"/>
                  <path d="M13.4004 10.2002L10.2004 15.0002L13.4004 19.8002" stroke="black" strokeWidth="1.4"/>
                </svg>
              </div>
              <div className="next-arrow" onClick={handleNext}>
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="15" cy="15" r="15" transform="matrix(-1 0 0 1 30 0)" fill="#E2E2E2"/>
                  <path d="M19.7998 15H10.1998" stroke="black" strokeWidth="1.4"/>
                  <path d="M16.5996 10.2002L19.7996 15.0002L16.5996 19.8002" stroke="black" strokeWidth="1.4"/>
                </svg>
              </div>
            </div>
          </div>
          <div className="bc-content">
            <div className="bc-sub-title">Bussiness Cloud</div>
            <div className="bc-title">Cloud Migration and Transformation Strategies</div>
            <div className="bc-desc">We develop effective strategies for the integration of company infrastructure into the Cloud, and successfully  migrate applications and databases to the Cloud system.</div>
            <div className="bc-btn">
              <Link to="#">
                <span>Keep reading</span>
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.3999 7.6001L0.599902 7.6001" stroke="black" strokeWidth="1.6"/>
                  <path d="M9.1333 14L13.4 7.6L9.1333 1.2" stroke="black" strokeWidth="1.6"/>
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="dt-case-study">
        <div className="o-container wd-container">
          <div className="p-top text-white mb-11 max-w-[1100px] mx-auto">
            <h2 className="text-white square-text-icon color-light-green mb-2">Case Study</h2>
            <p className="text-lg">We don't just build apps, we build global brands. Let's grow together.</p>
          </div>
          <div className="dt-case-studys-list flex flex-wrap gap-7">
            <div className="item relative overflow-hidden">
              <div className="img w-full h-full relative">
                <img src={pointDifImg1} alt="" />
                <div className="shadow absolute top-0 left-0 w-full h-full bg-black opacity-40"></div>
              </div>
              <div className="box absolute top-0 left-0 w-full h-full flex flex-col p-8">
                <div className="square mb-5 w-[23px] h-[23px] bg-[#0075FF]"></div>
                <h3 className="text-white text-2xl font-normal">Discover the Power of Cloud in<br/>Digital Transformation!</h3>
                <div className="buttons mt-auto">
                  <Link to="#" className="w-56 h-10 px-3 flex items-center text-white text-base font-normal" style={{ backgroundColor: '#0075FF' }}>
                    <span className="flex-1">#Viewpoint</span>
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.8 7.3999L-1.24574e-05 7.3999" stroke="#F5F5F5" strokeWidth="1.6"/>
                      <path d="M8.53336 13.7998L12.8 7.39981L8.53336 0.999805" stroke="#F5F5F5" strokeWidth="1.6"/>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
            <div className="item relative overflow-hidden">
              <div className="img w-full h-full relative">
                <img src={pointDifImg3} alt="" />
                <div className="shadow absolute top-0 left-0 w-full h-full bg-black opacity-40"></div>
              </div>
              <div className="box absolute top-0 left-0 w-full h-full flex flex-col p-8">
                <div className="square mb-5 "></div>
                <h3 className="text-white text-2xl font-normal">Blueprint's cloud solutions helped<br/>achieve significant cost savings and scalability.</h3>
                <div className="buttons mt-auto">
                  <Link to="#" className="w-56 h-10 px-3 flex items-center text-black text-base font-normal" style={{ backgroundColor: '#FFD747' }}>
                    <span className="flex-1">#Reposts</span>
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.8 7.3999L-1.24574e-05 7.3999" stroke="#000000" strokeWidth="1.6"/>
                      <path d="M8.53336 13.7998L12.8 7.39981L8.53336 0.999805" stroke="#000000" strokeWidth="1.6"/>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
            <div className="item relative overflow-hidden">
              <div className="img w-full h-full relative">
                <img src={pointDifImg4} alt="" />
                <div className="shadow absolute top-0 left-0 w-full h-full bg-black opacity-40"></div>
              </div>
              <div className="box absolute top-0 left-0 w-full h-full flex flex-col p-8">
                <div className="square mb-5 w-[23px] h-[23px] bg-[#FFFFFF]"></div>
                <h3 className="text-white text-2xl font-normal">Discover the Power of Cloud in<br/>Digital Transformation!</h3>
                <div className="buttons mt-auto">
                  <Link to="#" className="w-56 h-10 px-3 flex items-center text-white text-base font-normal" style={{ backgroundColor: '#7D63FF' }}>
                    <span className="flex-1">#Infographics</span>
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.8 7.3999L-1.24574e-05 7.3999" stroke="#F5F5F5" strokeWidth="1.6"/>
                      <path d="M8.53336 13.7998L12.8 7.39981L8.53336 0.999805" stroke="#F5F5F5" strokeWidth="1.6"/>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
            <div className="item relative overflow-hidden">
              <div className="img w-full h-full relative">
                <img src={pointDifImg1} alt="" />
                <div className="shadow absolute top-0 left-0 w-full h-full bg-black opacity-40"></div>
              </div>
              <div className="box absolute top-0 left-0 w-full h-full flex flex-col p-8">
                <div className="square mb-5 w-[23px] h-[23px] bg-[#0075FF]"></div>
                <h3 className="text-white text-2xl font-normal">Discover the Power of Cloud in<br/>Digital Transformation!</h3>
                <div className="buttons mt-auto">
                  <Link to="#" className="w-56 h-10 px-3 flex items-center text-white text-base font-normal" style={{ backgroundColor: '#0075FF' }}>
                    <span className="flex-1">#Viewpoint</span>
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.8 7.3999L-1.24574e-05 7.3999" stroke="#F5F5F5" strokeWidth="1.6"/>
                      <path d="M8.53336 13.7998L12.8 7.39981L8.53336 0.999805" stroke="#F5F5F5" strokeWidth="1.6"/>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
            <div className="item relative overflow-hidden">
              <div className="img w-full h-full relative">
                <img src={pointDifImg3} alt="" />
                <div className="shadow absolute top-0 left-0 w-full h-full bg-black opacity-40"></div>
              </div>
              <div className="box absolute top-0 left-0 w-full h-full flex flex-col p-8">
                <div className="square mb-5 "></div>
                <h3 className="text-white text-2xl font-normal">Blueprint's cloud solutions helped<br/>achieve significant cost savings and scalability.</h3>
                <div className="buttons mt-auto">
                  <Link to="#" className="w-56 h-10 px-3 flex items-center text-black text-base font-normal" style={{ backgroundColor: '#FFD747' }}>
                    <span className="flex-1">#Reposts</span>
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.8 7.3999L-1.24574e-05 7.3999" stroke="#000000" strokeWidth="1.6"/>
                      <path d="M8.53336 13.7998L12.8 7.39981L8.53336 0.999805" stroke="#000000" strokeWidth="1.6"/>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
            <div className="item relative overflow-hidden">
              <div className="img w-full h-full relative">
                <img src={pointDifImg4} alt="" />
                <div className="shadow absolute top-0 left-0 w-full h-full bg-black opacity-40"></div>
              </div>
              <div className="box absolute top-0 left-0 w-full h-full flex flex-col p-8">
                <div className="square mb-5 w-[23px] h-[23px] bg-[#FFFFFF]"></div>
                <h3 className="text-white text-2xl font-normal">Discover the Power of Cloud in<br/>Digital Transformation!</h3>
                <div className="buttons mt-auto">
                  <Link to="#" className="w-56 h-10 px-3 flex items-center text-white text-base font-normal" style={{ backgroundColor: '#7D63FF' }}>
                    <span className="flex-1">#Infographics</span>
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.8 7.3999L-1.24574e-05 7.3999" stroke="#F5F5F5" strokeWidth="1.6"/>
                      <path d="M8.53336 13.7998L12.8 7.39981L8.53336 0.999805" stroke="#F5F5F5" strokeWidth="1.6"/>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="dt-solution-partners" style={{ paddingTop: '220px', backgroundColor: '#000' }}>
        <div className="o-container wd-container">
          <div className="p-top text-white mb-11 max-w-[1100px] mx-auto">
            <h2 className="text-white square-text-icon color-light-green mb-2">Solution & Partners</h2>
            <p className="text-lg">Leave a lasting impact on your career journey with decisive strides.</p>
          </div>
          <div className="solution-partners-list">
            <div className="swiper-wrapper">
              <div className="swiper-slide item">
                <div className="img">
                  <img src={solutionPartnerImg1} alt="" />
                </div>
                <div className="box">
                  <div className="desc">Bringing together 65,000 dedicated professionals, the Accenture Microsoft Business Group / powered by Avanade / empowers enterprises to thrive.</div>
                  <div className="check-partners">
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="13" cy="13" r="13" fill="black"/>
                      <path d="M8 13L11 16L17 10" stroke="white" strokeWidth="2"/>
                    </svg>
                    <span><strong>Blueprint</strong> / Partners</span>
                  </div>
                </div>
              </div>
              <div className="swiper-slide item">
                <div className="img">
                  <img src={solutionPartnerImg1} alt="" />
                </div>
                <div className="box">
                  <div className="desc">Bringing together 65,000 dedicated professionals, the Accenture Microsoft Business Group / powered by Avanade / empowers enterprises to thrive.</div>
                  <div className="check-partners">
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="13" cy="13" r="13" fill="black"/>
                      <path d="M8 13L11 16L17 10" stroke="white" strokeWidth="2"/>
                    </svg>
                    <span><strong>Blueprint</strong> / Partners</span>
                  </div>
                </div>
              </div>
              <div className="swiper-slide item">
                <div className="img">
                  <img src={solutionPartnerImg1} alt="" />
                </div>
                <div className="box">
                  <div className="desc">Bringing together 65,000 dedicated professionals, the Accenture Microsoft Business Group / powered by Avanade / empowers enterprises to thrive.</div>
                  <div className="check-partners">
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="13" cy="13" r="13" fill="black"/>
                      <path d="M8 13L11 16L17 10" stroke="white" strokeWidth="2"/>
                    </svg>
                    <span><strong>Blueprint</strong> / Partners</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services; 